// Local Host Setup

// import axios from "axios";
// export const http = axios.create({ baseURL: "http://localhost:5009/" });
// export const barcode = "http://localhost:5009/images/barcodes/";
// export const server = "http://localhost:5009/";
// export const serverSocket = "http://localhost:5009/";
// export const apiUrlPatients = "http://localhost:5009/prijem/pacijenti/";
// export const apiUrlUputnice = "http://localhost:5009/prijem/uputnice/";
// export const apiUrlObradaPregled = "http://localhost:5009/obrada/pregled/";
// export const apiUrlNalaziPregled = "http://localhost:5009/nalazi/pregled";
// export const apiUrlNalaziOutbox = "http://localhost:5009/nalazi/outbox";
// export const apiUrlLabAssays = "http://localhost:5009/assays/lab";
// export const apiUrlAnaAssays = "http://localhost:5009/assays/ana";
// export const apiUrlControlClone = "http://localhost:5009/control/clone";
// export const apiUrlControlEdit = "http://localhost:5009/control/edit";
// export const apiUrlControlResults = "http://localhost:5009/control/results";
// export const apiUrlIntegration = "http://localhost:5009/api/pregled";
// export const apiUrlProdukt = "http://localhost:5009/inventar/produkti";
// export const apiUrlUgovor = "http://localhost:5009/inventar/ugovori";
// export const apiUrlStanje = "http://localhost:5009/inventar/stanje";
// export const apiUrlNarudzbenica = "http://localhost:5009/inventar/narudzbenice";
// export const apiUrlUlaz = "http://localhost:5009/inventar/ulazpregled";
// export const apiUrlIzlaz = "http://localhost:5009/inventar/izlazpregled";

// Client Setup - BH Telecom

import axios from "axios";
export const http = axios.create({ baseURL: "https://labmedical.ilab.ba/" });
export const barcode = "https://labmedical.ilab.ba/images/barcodes/";
export const server = "https://labmedical.ilab.ba/";
export const serverSocket = "https://labmedical.ilab.ba/";
export const apiUrlPatients = "https://labmedical.ilab.ba/prijem/pacijenti/";
export const apiUrlUputnice = "https://labmedical.ilab.ba/prijem/uputnice/";
export const apiUrlObradaPregled = "https://labmedical.ilab.ba/obrada/pregled/";
export const apiUrlNalaziPregled = "https://labmedical.ilab.ba/nalazi/pregled";
export const apiUrlNalaziOutbox = "https://labmedical.ilab.ba/nalazi/outbox";
export const apiUrlLabAssays = "https://labmedical.ilab.ba/assays/lab";
export const apiUrlAnaAssays = "https://labmedical.ilab.ba/assays/ana";
export const apiUrlControlClone = "https://labmedical.ilab.ba/control/clone";
export const apiUrlControlEdit = "https://labmedical.ilab.ba/control/edit";
export const apiUrlControlResults = "https://labmedical.ilab.ba/control/results";
export const apiUrlIntegration = "https://labmedical.ilab.ba/api/pregled";
export const apiUrlProdukt = "https://labmedical.ilab.ba/inventar/produkti";
export const apiUrlUgovor = "https://labmedical.ilab.ba/inventar/ugovori";
export const apiUrlStanje = "https://labmedical.ilab.ba/inventar/stanje";
export const apiUrlNarudzbenica = "https://labmedical.ilab.ba/inventar/narudzbenice";
export const apiUrlUlaz = "https://labmedical.ilab.ba/inventar/ulazpregled";
export const apiUrlIzlaz = "https://labmedical.ilab.ba/inventar/izlazpregled";


//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 127